import {ref} from 'vue';
import {useQuery, useMutation, useQueryClient} from '@tanstack/vue-query';
import axios from 'axios';
import Swal from "sweetalert2";

const isYearly = ref(false);
const billingPeriod = ref(false);

export const useBillingPackages = () => {
  const query = useQuery({
    queryKey: ['billing-packages'],
    queryFn: async () => {
      const {data} = await axios.get('/ajax/v2/billing/packages');
      billingPeriod.value = data.billing_period;
      if (billingPeriod.value === 'YEAR') {
        isYearly.value = true;
      }
      return data.data;
    },
  });

  return {
    isYearly,
    billingPeriod,
    ...query,
  };
};
